export enum OrderStatusType {
    Ordered = 0,
    Recived = 1,
    Served = 2,
    Paid = 3,
    Bill = 4,
    Finished = 5,
    Cancelled = 6
}

export function orderStatusTypeToString(status: OrderStatusType): string {
    switch (status) {
        case OrderStatusType.Ordered:
            return "Naručeno";
        case OrderStatusType.Recived:
            return "Primljeno";
        case OrderStatusType.Served:
            return "Posluženo";
        case OrderStatusType.Paid:
            return "Plaćeno";
        case OrderStatusType.Bill:
            return "Račun";
        case OrderStatusType.Cancelled:
            return "Otkazano";
        case OrderStatusType.Finished:
            return "Završeno";
        default:
            return "Nepoznato";
    }
}

export function orderStatusTypeToClassName(status: OrderStatusType): string {
    switch (status) {
        case OrderStatusType.Ordered:
            return "order-status ordered";
        case OrderStatusType.Recived:
            return "order-status recived";
        case OrderStatusType.Served:
            return "order-status served";
        case OrderStatusType.Paid:
            return "order-status paid";
        case OrderStatusType.Bill:
            return "order-status bill";
        case OrderStatusType.Cancelled:
            return "order-status cancelled";
        default:
            return "order-status unknown";
    }
}

export function orderStatusTypeStringToEnum(status: string): OrderStatusType {

    status = status.trim().toLowerCase();

    switch (status) {
        case "ordered":
            return OrderStatusType.Ordered;
        case "recived":
            return OrderStatusType.Recived;
        case "served":
            return OrderStatusType.Served;
        case "paid":
            return OrderStatusType.Paid;
        case "bill":
            return OrderStatusType.Bill;
        case "cancelled":
            return OrderStatusType.Cancelled;
        case "finished":
            return OrderStatusType.Finished;
        default:
            throw new Error("Invalid OrderStatusType string");
    }
}